import { render, staticRenderFns } from "./SolicitacoesDeKits.vue?vue&type=template&id=af4d457a"
import script from "./SolicitacoesDeKits.vue?vue&type=script&lang=js"
export * from "./SolicitacoesDeKits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports